import { RootState } from '@App/redux/store'

export const allTransactions = (state: RootState) => state.reports.transactions

export const allTradeTransactions = (state: RootState) => state.reports.tradeTransactions

export const allOrderTransactions = (state: RootState) => state.reports.orderTransactions

export const overallAnalytics = (state: RootState) => state.reports.overallAnalytics

export const topTradesAnalytics = (state: RootState) => state.reports.topUserTrades

export const marketAnalytics = (state: RootState) => state.reports.marketsAnalytics

export const popularAnalytics = (state: RootState) => state.reports.popularAnalytics

